<template>
    <div class="container" v-title="'我的报名'">
        <Navigation-bar title="我的报名"></Navigation-bar>
        <div class="container_content">
            <div class="tab" v-scrollShadow="tabIndex == 1 ? teamRoll : myEnrollRoll">
                <ul>
                    <li :class="{'active':tabIndex == 0}" @click="tabIndex=0">个人</li>
                    <li :class="{'active':tabIndex == 1}" @click="tabIndex=1">代表队</li>
                </ul>
            </div>
            <div id="EnrollRecord" ref="EnrollRecord">
                <Scroll
                    :scroll="myEnrollRoll"
                    @scrollChange="myEnrollRoll = $event"
                    @scrollEnd="myEnrollScrollEnd"
                    v-show="tabIndex == 0"
                >
                    <Pull-refresh 
                        v-model="pullRefresh.loading" 
                        loosing-text="释放刷新数据"
                        loading-text="正在刷新数据..." 
                        :success-text="pullRefresh.text" 
                        @refresh="onRefresh"
                    >
                        <div class="content" :style="minHeight == 0 ? '' : `min-height:${minHeight}px`">
                            <ul>
                                <li v-for="(item,index) in myEnroll.list" :key="index" @click="go(item)">
                                    <div class="match_info">
                                        <div @click.stop="$navigation.go('/Match/MatchDetail/' + item.LeagueId)">
                                            <img :src="item.LeagueLogo || require('@images/赛事logo_占位@2x.png')" @error="(e)=>{e.target.src = require('@images/赛事logo_占位@2x.png')}" class="match_logo">
                                            <span class="match_name">{{item.LeagueName}}</span>
                                            <YD-image src="icon/icon_card_入口_black"></YD-image>
                                        </div>
                                        <span class="status" :class="{'error': [4,6,8,9].includes(item.RecordStatus)}">{{statusText[item.RecordStatus]}}</span>
                                    </div>
                                    <div class="enroll_info">
                                        <div class="team_name" v-if="item.EnollType == 1">{{item.DeputationName}}（领队代报名）</div>
                                        <div class="team_name" v-else-if="item.EnollType == 2">自主报名</div>
                                        <div class="team_name" v-else-if="item.EnollType == 3">队友代报名</div>
                                        <div class="team_name" v-else></div>
                                        <p>比赛项目：{{item.EventsName}}</p>
                                        <p class="date" v-if="[1,2].includes(item.LeagueEnrollStatus)">报名时间：
                                            {{item.EnrollBeginTime | dateFormat('yyyy年MM月dd日')}} - 
                                            <template v-if="item.EnrollEndTime">{{item.EnrollEndTime | dateFormat('yyyy年MM月dd日')}}</template>
                                            <template v-else>暂无截止日期</template>
                                        </p>
                                        <p class="date" v-else-if="[3,4].includes(item.LeagueEnrollStatus)">公示时间：{{item.PublicBeginTime | dateFormat('yyyy年MM月dd日')}} - {{item.PublicEndTime | dateFormat('yyyy年MM月dd日')}}</p>
                                        <p class="date" v-else-if="[5,6].includes(item.LeagueEnrollStatus)">修改时间：{{item.PublicEndTime | dateFormat('yyyy年MM月dd日')}} - {{item.UpdateEndTime | dateFormat('yyyy年MM月dd日')}}</p>
                                        <p class="date" v-else-if="[7].includes(item.LeagueEnrollStatus)">比赛时间：
                                            <template v-if="item.BeginTime && item.EndTime">{{item.BeginTime | dateFormat('yyyy年MM月dd日')}} - {{item.EndTime | dateFormat('yyyy年MM月dd日')}}</template>
                                            <template v-else>{{['','','比赛时间待定','恢复时间待定'][item.AbnormalStatus]}}</template>
                                        </p>
                                        <div class="groups">
                                            <span v-for="(groupItem,groupIndex) in item.GroupList" :key="groupIndex">{{groupItem.Name}}</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div class="load_more" :style="myEnroll.loadMore == '无数据'?'padding-top:1.2rem':''" v-show="myEnroll.loadMore">
                                <img src="@images/no_data/暂无报名@2x.png" v-show="myEnroll.loadMore == '无数据'">
                                <span v-show="myEnroll.loadMore != '无数据'">{{myEnroll.loadMore}}</span>
                            </div>
                        </div>
                    </Pull-refresh>
                </Scroll>
                <Scroll
                    :scroll="teamRoll"
                    @scrollChange="teamRoll = $event"
                    @scrollEnd="teamScrollEnd"
                    v-show="tabIndex == 1"
                >
                    <Pull-refresh 
                        v-model="pullRefresh.loading" 
                        loosing-text="释放刷新数据"
                        loading-text="正在刷新数据..." 
                        :success-text="pullRefresh.text" 
                        @refresh="onRefresh"
                    >
                        <div class="content" :style="minHeight == 0 ? '' : `min-height:${minHeight}px`">
                            <ul>
                                <li v-for="(item,index) in teamEnroll.list" :key="index" @click="go(item)">
                                    <div class="match_info">
                                        <div @click.stop="$navigation.go('/Match/MatchDetail/' + item.LeagueId)">
                                            <img :src="item.LeagueLogo || require('@images/赛事logo_占位@2x.png')" @error="(e)=>{e.target.src = require('@images/赛事logo_占位@2x.png')}" class="match_logo">
                                            <span class="match_name">{{item.LeagueName}}</span>
                                            <YD-image src="icon/icon_card_入口_black"></YD-image>
                                        </div>
                                        <span class="status" :class="{'error': [4,6,8,9].includes(item.RecordStatus)}">{{statusText[item.RecordStatus]}}</span>
                                    </div>
                                    <div class="enroll_info">
                                        <div class="team_name">{{item.DeputationName}}</div>
                                        <p>比赛项目：{{item.EventsName}}</p>
                                        <p class="date" v-if="[1,2].includes(item.LeagueEnrollStatus)">报名时间：
                                            {{item.EnrollBeginTime | dateFormat('yyyy年MM月dd日')}} - 
                                            <template v-if="item.EnrollEndTime">{{item.EnrollEndTime | dateFormat('yyyy年MM月dd日')}}</template>
                                            <template v-else>暂无截止日期</template>
                                        </p>
                                        <p class="date" v-else-if="[3,4].includes(item.LeagueEnrollStatus)">公示时间：{{item.PublicBeginTime | dateFormat('yyyy年MM月dd日')}} - {{item.PublicEndTime | dateFormat('yyyy年MM月dd日')}}</p>
                                        <p class="date" v-else-if="[5,6].includes(item.LeagueEnrollStatus)">修改时间：{{item.PublicEndTime | dateFormat('yyyy年MM月dd日')}} - {{item.UpdateEndTime | dateFormat('yyyy年MM月dd日')}}</p>
                                        <p class="date" v-else-if="[7].includes(item.LeagueEnrollStatus)">比赛时间：
                                            <template v-if="item.BeginTime && item.EndTime">{{item.BeginTime | dateFormat('yyyy年MM月dd日')}} - {{item.EndTime | dateFormat('yyyy年MM月dd日')}}</template>
                                            <template v-else>{{['','','比赛时间待定','恢复时间待定'][item.AbnormalStatus]}}</template>
                                        </p>
                                        <div class="groups">
                                            <span v-for="(groupItem,groupIndex) in item.GroupList" :key="groupIndex">{{groupItem.Name}}</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div class="load_more" :style="teamEnroll.loadMore == '无数据'?'padding-top:1.2rem':''" v-show="teamEnroll.loadMore">
                                <img src="@images/no_data/暂无报名@2x.png" v-show="teamEnroll.loadMore == '无数据'">
                                <span v-show="teamEnroll.loadMore != '无数据'">{{teamEnroll.loadMore}}</span>
                            </div>
                        </div>
                    </Pull-refresh>
                </Scroll>
            </div>
        </div>
    </div>
</template>
<script>
import { PullRefresh } from 'vant';
import 'vant/lib/pull-refresh/style';
import {
    GetMyDeputationEnrollRecordList,
    GetMyLeagueEnrollRecordList
} from "@/api"
import communicate from '@/common/communicate.js';

export default {
    name:"EnrollRecord",
    components:{
        PullRefresh
    },
    data(){
        let index = this.$route.query.index;
        return {
            teamRoll:0,
            myEnrollRoll:0,
            tabIndex: index || 0,
            minHeight:0,
            teamEnroll:{
                list: [],
                lastId: 0,
                loadMore: "",
                isGetData: true
            },
            myEnroll:{
                list: [],
                lastId: 0,
                loadMore: "",
                isGetData: true
            },
            pullRefresh:{
                loading:false,
                text:''
            }
        }
    },
    created(){
        this.getTeamEnrollList(0);
        this.getMyEnrollList(0);
        communicate.paySuccess.$on(()=>{
            if(this.tabIndex == 0){
                this.getMyEnrollList(0);
            }else{
                this.getTeamEnrollList(0);
            }
        })
    },
    mounted(){
        this.minHeight = this.$refs['EnrollRecord'].offsetHeight;
    },
    destroyed(){
        communicate.paySuccess.$off();
    },
    computed:{
		statusText(){
			return ['','未提交审核','组委会审核中','组委会审核中','审核有问题','公示中','公示有问题','报名成功','报名失败','未支付服务费'];
		}
    },
    watch:{
        '$store.state.monitor.ONESELF_ENROLL_DELETE': {
            deep: true,
            handler({value}){
                let id = value;
                if(this.tabIndex == 0){
                    let obj = this.myEnroll;
                    let list = [...obj.list];
                    for(var i=0;i<list.length;i++){
                        if(id == list[i].LeagueId){
                            list.splice(i,1);
                            break;
                        }
                    }
                    this.$set(obj,'list',list);
                }else{
                    let obj = this.teamEnroll;
                    let list = [...obj.list];
                    for(var i=0;i<list.length;i++){
                        if(id == list[i].DeputationEnrollId){
                            list.splice(i,1);
                            break;
                        }
                    }
                    this.$set(obj,'list',list);
                }
            }
        },
        tabIndex(){
            this.pullRefresh.text = "";
            this.pullRefresh.loading = false;
        }
    },
    methods:{
        teamScrollEnd(){
            if(this.teamEnroll.isGetData){
                this.getTeamEnrollList(this.teamEnroll.lastId);
            }
        },
        getTeamEnrollList(LastId,isRefresh){
            var teamEnroll = this.teamEnroll;
            if(!isRefresh){
                teamEnroll.isGetData = false;
                teamEnroll.loadMore = "数据加载中";
            }
            GetMyDeputationEnrollRecordList({
                Continuation: {
                    LastId,
                    MaxCount: 20
                }
            }).then(data=>{
                teamEnroll.loadMore = "";
                teamEnroll.isGetData = true;
                this.pullRefresh.loading = false;
                if(data.Code == 0){
                    if(isRefresh){
                        this.pullRefresh.text = "数据刷新成功";
                    }
                    let ContinueList = data.ContinueList || [];
                    if(ContinueList.length == 0){
                        if(LastId == 0){
                            teamEnroll.loadMore = "无数据";
                        }else{
                            teamEnroll.loadMore = "到底了";
                        }
                        teamEnroll.isGetData = false;
                    }else{
                        let list = [];
                        if(LastId != 0){
                            list = JSON.parse(JSON.stringify(teamEnroll.list));
                        }
                        teamEnroll.lastId = ContinueList[ContinueList.length - 1].DeputationEnrollId;
                        this.$set(teamEnroll,'list',[...list, ...ContinueList]);
                    }
                }else{
                    if(isRefresh){
                        this.pullRefresh.text = "数据刷新失败";
                    }
                }
            }).catch(()=>{
                if(isRefresh){
                    this.pullRefresh.loading = false;
                    this.pullRefresh.text = "数据刷新失败";
                }else{
                    teamEnroll.isGetData = true;
                    teamEnroll.loadMore = "数据加载失败";
                }
            })
        },
        myEnrollScrollEnd(){
            if(this.myEnroll.isGetData){
                this.getMyEnrollList(this.myEnroll.lastId);
            }
        },
        getMyEnrollList(LastId,isRefresh){
            var myEnroll = this.myEnroll;
            if(!isRefresh){
                myEnroll.isGetData = false;
                myEnroll.loadMore = "数据加载中";
            }
            GetMyLeagueEnrollRecordList({
                Continuation: {
                    LastId,
                    MaxCount: 20
                }
            }).then(data=>{
                myEnroll.loadMore = "";
                myEnroll.isGetData = true;
                this.pullRefresh.loading = false;
                if(data.Code == 0){
                    if(isRefresh){
                        this.pullRefresh.text = "数据刷新成功";
                    }
                    let ContinueList = data.ContinueList || [];
                    if(ContinueList.length == 0){
                        if(LastId == 0){
                            myEnroll.loadMore = "无数据";
                        }else{
                            myEnroll.loadMore = "到底了";
                        }
                        myEnroll.isGetData = false;
                    }else{
                        let list = [];
                        if(LastId != 0){
                            list = JSON.parse(JSON.stringify(myEnroll.list));
                        }
                        myEnroll.lastId = ContinueList[ContinueList.length - 1].UserEnrollId;
                        this.$set(myEnroll,'list',[...list, ...ContinueList]);
                    }
                }else{
                    if(isRefresh){
                        this.pullRefresh.text = "数据刷新失败";
                    }
                }
            }).catch(()=>{
                if(isRefresh){
                    this.pullRefresh.loading = false;
                    this.pullRefresh.text = "数据刷新失败";
                }else{
                    myEnroll.isGetData = true;
                    myEnroll.loadMore = "数据加载失败";
                }
            })
        },
        onRefresh(){
            if(this.tabIndex == 0){
                this.getMyEnrollList(0,true);
            }else if(this.tabIndex == 1){
                this.getTeamEnrollList(0,true);
            }
        },
        go(obj){
            let path;
            if (obj.DeputationEnrollId) {
                if(obj.EnollType == 1 && ![7,8].includes(obj.RecordStatus)){
                    path = `/Enroll/LookTeamAuditDetail?deputationEnrollId=${obj.DeputationEnrollId}`;
                }else{
                    switch (obj.RecordStatus) {
                        case 7:
                            path =`/Enroll/EnrollDetail?deputationEnrollId=${obj.DeputationEnrollId}&success=1`;
                            break;
                        case 8:
                            path =`/Enroll/EnrollDetail?deputationEnrollId=${obj.DeputationEnrollId}&success=0`;
                            break;
                        case 9:
                            path =`/Enroll/TeamPersonnel?deputationEnrollId=${obj.DeputationEnrollId}&subLeagueId=${obj.LeagueId}`;
                            break;
                        default:
                            path =`/Enroll/TeamAuditDetail?deputationEnrollId=${obj.DeputationEnrollId}&subLeagueId=${obj.LeagueId}`;
                            break;
                    }
                }
            } else {
                switch (obj.RecordStatus) {
                    case 7:
                        path = `/Enroll/OneselfEnroll/EnrollDetail?subLeagueId=${obj.LeagueId}&success=1`;
                        break;
                    case 8:
                        path = `/Enroll/OneselfEnroll/EnrollDetail?subLeagueId=${obj.LeagueId}&success=0`;
                        break;
                    case 9:
                        path = `/Enroll/OneselfEnroll/Personnel?subLeagueId=${obj.LeagueId}`;
                        break;
                    default:
                        path = `/Enroll/OneselfEnroll/AuditDetail?subLeagueId=${obj.LeagueId}`;
                        break;
                }
            }
            this.$navigation.go(path);           
        }
    }
}
</script>
<style lang="scss" scoped>
.tab{
    width: 100%;
    height: 80px;
    position: relative;
    z-index: 1;
    ul {
        display: flex;
        li{
            flex: 1;
            @include line-height(80px);
            font-size: 32px;
            color: #1B1C1E;
            font-weight: 500;
            text-align: center;
            &.active{
                color: #7AD21A;
                border-bottom: 1px #7AD21A solid;
            }
        }
    }
}
.content{
    width: 100%;
    height: auto;
    padding: 40px 40px 70px;
    box-sizing: border-box;
    ul li{
        width: 100%;
        height: auto;
        padding: 0 26px;
        box-sizing: border-box;
        background: #FFFFFF;
        box-shadow: 0px 4px 20px -4px rgba(136,136,136,0.25);
        border-radius: 20px;
        margin-bottom: 24px;
        .match_info{
            height: 120px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px #F0F0F0 solid;
            >div{
                display: flex;
                align-items: center;
            }
            .match_logo{
                height: 56px;
                width: 56px;
                border-radius: 12px;
                margin-right: 16px;
            }
            .match_name{
                max-width: 300px;
                font-size: 28px;
                color: #1B1C1E;
                font-weight: 500;
                @include ellipsis;
            }
            .match_name + img{
                width: 32px;
                height: 32px;
            }
            .status{
                font-size: 28px;
                color: #7E7E7F;
                font-weight: 400;
                &.error{
                    color: #F06E43;
                }
            }
        }
        .enroll_info{
            padding-top: 31px;
            .team_name{
                font-size: 32px;
                color: #1B1C1E;
                font-weight: 500;
                line-height: 44px;
                margin-bottom: 16px;
            }
            p{
                font-size: 28px;
                color: #7E7E7F;
                font-weight: 400;
                line-height: 40px;
                margin-bottom: 8px;
                &:last-of-type{
                    margin-bottom: 0;
                }
                &.date{
                    white-space: nowrap;
                    letter-spacing: -1px;
                }
            }
            .groups{
                margin-top: 32px;
                padding-bottom: 24px;
                span{
                    display: inline-block;
                    min-height: 48px;
                    padding: 4px 8px;
                    box-sizing: border-box;
                    background: #FAFBFA;
                    margin-right: 8px;
                    margin-bottom: 8px;
                    border-radius: 8px;
                    font-size: 28px;
                    color: #7AD21A;
                    font-weight: 400;
                    line-height: 40px;
                }
            }
        }
    }
}
</style>